<template>
  <v-sheet color="blue-grey-lighten-5">
    <v-container>
      <v-row>
        <v-col>
          <h2 class="text-h3 text-md-h2 text-center font-weight-bold mb-sm-3">
            Our Services
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-card class="fill-height pa-2" variant="flat">
            <v-card-title
              >Complete major and minor collision repair</v-card-title
            >
            <v-card-text class="text-body-1">
              <p class="mb-3">
                West Wind Automotive uses the latest technology to restore your
                vehicle to pre-accident condition (often times, even better than
                pre-accident!).
              </p>
              <p class="mb-3">
                For vehicles that don’t have structural damage, we will provide
                you with the best time estimate required to complete the work on
                your car. The majority of auto body repairs fall into this
                category.
              </p>
              <p class="mb-3">
                If your vehicle has been diagnosed as having structural damage -
                all structural repairs require precise equipment to enable
                accurate measurement and exact re-construction of your vehicle
                to factory standards. We use Car-O-Liner - the Car-O-Liner
                allows us to pull the frame of your car back to what it was when
                the vehicle left the factory.
              </p>
              <p>
                Depending on the accident and level of damage to your vehicle,
                it may be determined to be a “total loss”. A “total loss” is
                when the cost of repairs exceeds the value of your car. This
                status is determined by a combination of our evaluation and your
                insurance company.
              </p>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6"> <RepairService /> </v-col>

        <v-col cols="12" md="6">
          <v-card class="fill-height pa-2" variant="flat">
            <v-card-title> Paint-less dent repair </v-card-title>
            <v-card-text class="text-body-1">
              <p class="mb-3">
                A skilled paint-less dent repair technician can remove dents
                like nothing ever happened.
              </p>

              <RepairInfoSteps subject="Paint-less dent repair inquiry" />
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card class="fill-height pa-2" variant="flat">
            <v-card-title> Headlight restoration </v-card-title>
            <v-card-text class="text-body-1">
              <p class="mb-3">
                Headlight lenses that have succumbed to oxidation and other
                environmental hazards of travel and weather can result in cloudy
                lenses and reduced night time visibility.
              </p>
              <p>
                West Wind Automotive offers professional headlight restoration
                services for only $50 for both headlights.
              </p>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card class="fill-height pa-2" variant="flat">
            <v-card-title> Lease return repair </v-card-title>
            <v-card-text class="text-body-1">
              <p class="mb-3">
                Avoid unnecessary and costly lease return repair charges.
              </p>
              <p>
                West Wind Automotive can examine your vehicle for damage that
                you will likely be charged for when your lease expires. We will
                then provide you a free estimate which offers you the repair
                solution that best fits your automotive needs and helps reduce
                expensive fines when returning your leased vehicle.
              </p>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card class="fill-height pa-2" variant="flat">
            <v-card-title> Rental car and towing </v-card-title>
            <v-card-text class="text-body-1">
              <p class="mb-3">
                West Wind Automotive can help set up insurance or customer-paid
                rental cars with repairs, in addition to complementary Lyft
                rides within the city when dropping off your car for repair.
              </p>
              <p class="mb-3">
                We can also assist you with towing or road service!
              </p>
              <p class="font-weight-bold">
                For more information, please
                <a
                  :href="`mailto:${infoEmail}?subject=Towing and rental car inquiry`"
                  class="text-primary"
                  >email</a
                >
                or
                <a :href="`tel:${contactPhone}`" class="text-primary">call us</a
                >.
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script setup lang="ts">
const infoEmail = import.meta.env.VITE_EMAIL
const contactPhone = import.meta.env.VITE_PHONE
</script>
